<template>
  <app-bottom-sheet class="grid gap-4">
    <course-page-enrolment-actions
      v-if="nextSession && isAuthenticated"
      :course="course"
      :session="nextSession"
    />

    <course-page-program-download-cta v-else block :course="course" />

    <p class="-mt-2 text-center text-sm text-subtle">
      <span v-if="nextSessionFormattedStartDate">
        Prochaine session le
        <strong>{{ nextSessionFormattedStartDate }}</strong>
      </span>
      <span v-else
        >Prochaine session bientôt dispo.
        <course-new-session-alert-cta
          color="dark"
          :course="course"
          size="small"
          variant="link"
      /></span>
    </p>
  </app-bottom-sheet>
</template>

<script lang="ts" setup>
import type { CoursePageView } from "~/business-areas/course/course.model";
import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";
import CoursePageEnrolmentActions from "~/pages/courses/[slug]/_includes/components/enrolment/course-page-enrolment-actions.vue";
import CoursePageProgramDownloadCta from "~/pages/courses/[slug]/_includes/components/program/course-page-program-download-cta.vue";

const properties = defineProps<{
  course: CoursePageView;
  nextSession?: CourseSessionView;
}>();

const { isAuthenticated } = useCurrentUser();

const nextSessionFormattedStartDate = computed(() => {
  if (!properties.nextSession) return;

  return useCourseSessionInfo(properties.nextSession).formattedDate.value;
});
</script>
